/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export default class Resource
{
  constructor (cass, settings)
  {
    this.cass = cass;
    this.settings = settings;
  }


  getResourceSettings ()
  {
    return this.settings;
  }


};
